import React from 'react';
import { Box, Image, Text } from '@chakra-ui/react';

import { categoryImage } from '../../hooks/useCatalog';

const ColumnHeading = ({ children }) => (
    <Text fontSize='12px' fontWeight={700} textTransform='uppercase' letterSpacing='0.02em' color='raano.ink' mb='14px' >{children}</Text>
);

const MenuLink = ({ children, onClick }) => (
    <Text as='button' display='block' textAlign='left' fontSize='13px' color='blackAlpha.700' py='5px' transition='color .125s' _hover={{ color: 'raano.black' }} onClick={onClick} >{children}</Text>
);

// Full-width panel under the header: link columns on the left, two photo tiles on the right (design-system.md §3.2)
const MegaMenu = ({ genre, categories, products, go, onMouseEnter, onMouseLeave }) => {

    const tiles = categories.filter(c => categoryImage(products, c._id)).slice(0, 2);

    return (
        <Box position='absolute' top='100%' left={0} right={0} bg='raano.white' borderTop='1px solid' borderBottom='1px solid' borderColor='raano.border' boxShadow='0 12px 24px rgba(0,0,0,0.06)' onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} sx={{ animation: 'megaIn .2s ease-out', '@keyframes megaIn': { from: { opacity: 0, transform: 'translateY(-6px)' }, to: { opacity: 1, transform: 'none' } } }} >
            <Box display='flex' px='40px' py='28px' gap='40px' >
                <Box display='flex' gap='72px' flex={1} >
                    <Box>
                        <ColumnHeading>{genre.name}'s wear</ColumnHeading>
                        {categories.map(c => <MenuLink key={c._id} onClick={() => go('/search', { categoryId: c._id })} >{c.name}</MenuLink>)}
                    </Box>
                    <Box>
                        <ColumnHeading>Collections</ColumnHeading>
                        <MenuLink onClick={() => go('/search', {})} >New arrivals</MenuLink>
                        <MenuLink onClick={() => go('/search', { maxPrice: 999 })} >Under ₹999</MenuLink>
                        <MenuLink onClick={() => go('/search', {})} >Shop all</MenuLink>
                    </Box>
                </Box>
                <Box borderLeft='1px solid' borderColor='raano.border' pl='40px' display='flex' gap='16px' >
                    {tiles.map(c => (
                        <Box key={c._id} as='button' position='relative' width='330px' height='450px' overflow='hidden' bg='raano.imageBg' onClick={() => go('/search', { categoryId: c._id })} role='group' >
                            <Image src={categoryImage(products, c._id)} alt={c.name} width='100%' height='100%' objectFit='cover' transition='transform .5s' _groupHover={{ transform: 'scale(1.04)' }} />
                            <Box position='absolute' inset={0} bgGradient='linear(to-t, blackAlpha.600, transparent 45%)' />
                            <Text position='absolute' bottom='22px' left={0} right={0} textAlign='center' color='raano.white' fontSize='28px' fontWeight={700} textTransform='uppercase' sx={{ fontStretch: '75%' }} >{c.name}</Text>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default MegaMenu;
